import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";

const LINKS = [
  { label: "Products", href: "#products" },
  { label: "Project", href: "#project" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.9 }}
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0B0F17]/85 border-amber-500/20"
          : "bg-transparent border-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 group" data-testid="header-logo">
          <span className="w-3 h-3 bg-amber-500 transition-transform duration-300 group-hover:rotate-45" />
          <span className="font-display text-2xl font-800 font-bold tracking-[0.18em] text-white">
            RORIX
          </span>
          <span className="hidden sm:block font-mono2 text-[10px] tracking-[0.3em] text-zinc-500 uppercase mt-1">
            Road Safety Systems
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono2 text-xs tracking-[0.2em] uppercase text-zinc-400 hover:text-amber-400 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="header-quote-button"
            className="clip-notch bg-amber-500 text-[#0B0F17] font-display font-bold tracking-widest uppercase text-sm px-5 py-2.5 flex items-center gap-1.5 hover:bg-amber-400 transition-colors duration-300"
          >
            Get a Quote <ArrowUpRight className="w-4 h-4" />
          </a>
        </nav>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0B0F17]/95 backdrop-blur-xl border-t border-amber-500/20 px-6 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-mono2 text-sm tracking-[0.2em] uppercase text-zinc-300"
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </motion.header>
  );
};
